function Link() {
  return {
    MuiLink: {
      defaultProps: {
        underline: "hover",
        // color: "white"
      },
    },
  };
}

export default Link;
